<template>
  <div
      class="d-flex flex-column rounded-1 bg-theme-transparent gmb-block--floating-box"
  >
    <GmbSection
        :childCheckboxActivatedValues="activatedMapOptionSlugs"
        :childCheckboxAllValues="mapOptionSlugs"
        :disableSelectAllOrNoneButton="true"
        :displayLevel="1"
        isCollapsible
        lockHeader
        title="Options d'affichage"
        @child-checkbox-activated-values-changed="
        (newActivatedMapOptionSlugs) =>
          $emit('activated-map-options-changed', newActivatedMapOptionSlugs)
      "
    >
      <template #picto>
        <FdText colorTheme4 fa>
          <i class="fa-solid fa-list-check"/>
        </FdText>
      </template>

      <template #infoSticker>
        <GmbSticker>{{
            activatedMapOptionCount + "/" + mapOptionCount
          }}
        </GmbSticker>
      </template>

      <GmbRow
          v-for="(mapOption, i) in mapOptions"
          :class="{ 'mt-2': i != 0 }"
          :controlValue="mapOption.slug"
          isCheckbox
          :key="i"
          switcherStyle
      >
        <template #picto>
          <FdText fa>
            <i :class="mapOption.fAPictoCssClasses"/>
          </FdText>
        </template>

        <FdText tag="span">{{ mapOption.label }}</FdText>
      </GmbRow>
      <b-form-select class="mt-2" v-model="selectedMapBackgroundIdxModel"
                     :options="mapBackgroundSelectOptions"></b-form-select>
    </GmbSection>
  </div>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "MapOptions",

  components: {
    FdText,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  data() {
    return {
      mapOptions: [
        {
          fAPictoCssClasses: "fas fa-sitemap",
          label: "Regroupement des marqueurs",
          slug: "use-map-clustering",
        },
        {
          fAPictoCssClasses: "fas fa-eye-low-vision",
          label: "Cacher tous les marqueurs de sites",
          slug: "hide-all-organizations",
        },
        {
          fAPictoCssClasses: "far fa-eye-slash",
          label: "Exclure les sites vides",
          slug: "hide-empty-organizations",
        },
      ],
    };
  },

  props: {
    activatedMapOptionSlugs: {
      default: () => {
        return [];
      },
      type: Array,
    },
    mapConfiguration: Object,
    selectedMapBackgroundIdx: Number,
  },

  computed: {

    selectedMapBackgroundIdxModel: {
      get() {
        return this.selectedMapBackgroundIdx.toString();
      },
      set(newSelectedMapBackgroundIdx) {
        this.$emit("selected-map-background-idx-changed", parseInt(newSelectedMapBackgroundIdx, 10));
      },
    },

    activatedMapOptionCount() {
      return this.activatedMapOptionSlugs.length;
    },

    mapOptionCount() {
      return this.mapOptionSlugs.length;
    },

    mapOptionSlugs() {
      let slugs = [];

      for (const mapOption of this.mapOptions) slugs.push(mapOption.slug);

      return slugs;
    },

    mapBackgroundSelectOptions() {
      if (!this.mapConfiguration) return [];
      //console.log(">>>>>>>>>>>>>", this.mapConfiguration);
      return this.mapConfiguration.mapBackgrounds.map(
          (item, idx) => {
            return {value: idx.toString(), text: item.label}
          }
      )
    }
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
